import { Hex } from 'viem'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type TransferOwnershipStore = {
    initiatedSpace:
        | {
              imgSrc: string | undefined
              name: string | undefined
              tokenId: string | undefined
              spaceId: string | undefined
              channelId: string | undefined
              cooldownEnd: Hex
          }
        | undefined
    setinitiatedSpace: (initiatedSpace: TransferOwnershipStore['initiatedSpace']) => void
    resetInitiatedSpace: () => void
}

export const useOwnershipTransferStore = create<TransferOwnershipStore>()(
    persist(
        (set) => ({
            initiatedSpace: undefined,
            setinitiatedSpace: (initiatedSpace) => set({ initiatedSpace }),
            resetInitiatedSpace: () => set({ initiatedSpace: undefined }),
        }),
        {
            name: 'town/ownership-transfer',
            version: 1,
            partialize: (state) => ({ initiatedSpace: state.initiatedSpace }),
        },
    ),
)
